import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import AspectRatio from "@mui/joy/AspectRatio";
import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import Typography from "@mui/joy/Typography";
import Grid from "@mui/joy/Grid";
import CardOverflow from "@mui/joy/CardOverflow";
import Chip from "@mui/joy/Chip";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import AutoAwesomeMotionIcon from "@mui/icons-material/AutoAwesomeMotion";
import PublicIcon from "@mui/icons-material/Public";
import { IconButton } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ScheduleIcon from "@mui/icons-material/Schedule";

export default function TarjetaDetalleAventura({
  imagen,
  latitud,
  longitud,
  pais,
  ciudad,
  titulo,
  nivel,
  categoria,
  descripcion,
  punto_de_encuentro,
  fecha,
}) {
  let enlaceGoogleMaps = () => {
    let zoom = 0;
    window.open(`https://www.google.com/maps?q=${latitud},${longitud}`);
  };
  let fechaFormato = new Date(fecha);

  return (
    <Box
      sx={{
        display: "flex",
        alignContent: "center",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Card variant="outlined" sx={{ width: "80%" }}>
        <CardOverflow>
          <AspectRatio ratio="2">
            <img src={imagen} alt="" />
          </AspectRatio>
          <IconButton
            disabled
            aria-label="Pais y Ciudad"
            size="md"
            variant="solid"
            color="danger"
            sx={{
              position: "absolute",
              zIndex: 2,
              borderRadius: "50%",
              right: "1rem",
              bottom: 0,
              transform: "translateY(50%)",
            }}
          >
            <Chip
              sx={{ borderRadius: "8px" }}
              size="sm"
              startDecorator={<PublicIcon />}
            >
              {pais},{ciudad}
            </Chip>
          </IconButton>
        </CardOverflow>
        <CardContent>
          <Typography level="title-lg" sx={{ marginBottom: "0.5rem" }}>
            {titulo}
          </Typography>
          <Box sx={{ display: { xs: "grid", md: "flex", lg: "flex" }, gap: 2 }}>
            <Chip
              sx={{ borderRadius: "8px", backgroundColor: "#fbf2dc" }}
              size="sm"
              startDecorator={<PriorityHighIcon />}
            >
              Nivel {nivel}
            </Chip>
            <Chip
              sx={{ borderRadius: "8px", backgroundColor: "#fbf2dc" }}
              size="sm"
              startDecorator={<AutoAwesomeMotionIcon />}
            >
              {categoria}
            </Chip>
            <Chip
              sx={{ borderRadius: "8px", backgroundColor: "#fbf2dc" }}
              size="sm"
              startDecorator={<ScheduleIcon />}
            >
              {fechaFormato.toLocaleDateString("es-ES", {
                day: "2-digit",
                month: "long",
                year: "numeric",
                timeZone: "UTC",
              })}
            </Chip>
          </Box>

          <Typography level="body-sm" sx={{ mt: "0.5rem" }}>
            {descripcion}
          </Typography>
          <Card variant="soft" sx={{ marginTop: "1rem" }}>
            <Chip
              sx={{ borderRadius: "8px" }}
              size="sm"
              startDecorator={<LocationOnIcon />}
            >
              Punto de Encuentro
            </Chip>
            <Grid
              container
              spacing={2}
              sx={{ flexGrow: 1, alignItems: "center" }}
            >
              <Grid
                item
                xs={12} // Ocupa todo el ancho en pantallas pequeñas
                sm={8} // Ocupa 8 columnas en pantallas medianas en adelante
              >
                <Typography level="title-sm">{punto_de_encuentro}</Typography>
              </Grid>
              <Grid
                item
                xs={12} // Botón en una fila separada en pantallas pequeñas
                sm={4} // Botón ocupa 4 columnas en pantallas medianas en adelante
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", sm: "flex-end" }, // Centra en pantallas pequeñas, alinea a la derecha en mayores
                }}
              >
                <Button
                  variant="outlined"
                  color="neutral"
                  size="xs"
                  onClick={enlaceGoogleMaps}
                >
                  Ver en Google Maps
                </Button>
              </Grid>
            </Grid>
          </Card>
        </CardContent>
      </Card>
    </Box>
  );
}
